import React from "react";
import {Box, Card, CardContent, Grid, Typography} from "@mui/material";

const NoSubscriptions = () => {

    return (
        <Grid item xs={12} >
            <Card className="card">
                <CardContent>
                    <Box className="card-content">
                        <Typography variant="h2">No subscriptions found</Typography>
                        <Typography variant="body1">You will need at least one subscription to a service to use Centric.</Typography>
                        <Typography variant="body1">If you think you should see one or more subscriptions on this page, please contact support.</Typography>
                    </Box>
                </CardContent>
            </Card>


        </Grid>
    );
}

export default NoSubscriptions;